import React from 'react';

import { Select } from 'antd';

import useTagCatalog from '@hooks/CachedLists/UseTagCatalog';

const InputTag = ({ contactType, onChange, publicOnly = false, value, disabled }) => {
    const allTags = useTagCatalog(contactType, { publicOnly });

    const handleChange = (values) => {
        onChange(values);
    };

    return (
        <Select
            autoComplete="off"
            mode="multiple"
            value={value}
            placeholder="Select one or more tags"
            onChange={handleChange}
            disabled={disabled}
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            style={{ width: '100%' }}
            optionFilterProp="label"
            options={allTags.map((tag) => ({ label: tag.Name, value: tag.ID }))}
        />
    );
};

export default InputTag;
